module.exports = __webpack_public_path__ + "assets/8dc5bdb4679e97d8156693e00e650326.mp3";